<template>
  <div class="row">
    <div class="form">
        <b-message type="is-danger" v-if="error">{{ error }}</b-message>
      <h1 class="title">Login</h1>

      <div class="">
        <b-field label="Email">
          <b-input icon="email" type="email" v-model="email" />
        </b-field>
        <b-field label="Password">
          <b-input
            icon="lock"
            class="is-success"
            type="password"
            password-reveal
            v-model="password"
            expanded
          />
        </b-field>

         <b-button @click='onSubmit' expanded type='is-success' :loading='loading' label='LOG IN'></b-button>
      </div>
    </div>
  </div>
</template>
<script src="iziToast.min.js" type="text/javascript"></script> 
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["isLoggedIn"]),
    nextRoute() {
      return this.$route.query.redirect || "/";
    }
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      error: "",
      isSuccess: false
    };
  },
  watch: {
    isLoggedIn: function(changedUser) {
      if (changedUser) {
        this.$router.replace(this.nextRoute);
      }
    }
  },
  methods: {
    ...mapActions(["addMessage", "clearMessage", "loginWithEmail"]),
    onSubmit() {
      this.loading = true;
      let data = {
        email: this.email,
        password: this.password
      };
      this.loginWithEmail(data)
        .then(() => {
          setTimeout(
              () =>
                this.$buefy.toast.open({
                  message: `LOG-IN SUCCESSFUL`,
                  type: "is-success",
                  position: "is-bottom-right"
                }),
              2000
            );
          this.isSuccess = true;
          this.$router.push({
            name: "mainpage"
          });
        })
        .catch(error => {
          this.loading = false;
          this.error = error.message;
          (this.email = ""), (this.password = "");
        })
        .then(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
<style>
.form {
  display: flex;
  margin: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
}
</style>
